// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:25.519Z
// Property: Park at Tuscany (ID: 6767906449165616)
// Collections: 24 amenities, 6 floorplans (live), 15 photos, 52 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165616",
  "property_external_id": "qbpgj1y",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/park-at-tuscany/5XrZTh/",
  "property_apartments_url": "https://www.apartments.com/park-at-tuscany-oklahoma-city-ok/qbpgj1y/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+at+Tuscany/data=!4m2!3m1!1s0x0:0x20b78c93a0aea500?sa=X&ved=2ahUKEwieg_vH_LySAxVRlIkEHbLkCGcQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-at-tuscany",
  "property_name": "Park at Tuscany",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/park-at-tuscany/",
  "property_domain": null,
  "property_address": "2737 NW 140th Street",
  "property_full_address": "2737 NW 140th Street, Oklahoma City, OK, 73134",
  "property_address_1": "2737 NW 140th Street",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73134",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.6149",
  "property_address_longitude": "-97.5625",
  "property_email": "parkattuscany@caseusa.com",
  "property_phone": "4053907547",
  "property_call_tracking_phone": "844-977-4239",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Park at Tuscany in Oklahoma City, luxury meets comfort. Choose from spacious one and two-bedroom floor plans, and unwind by the sparkling pool or in the inviting clubhouse. With an array of modern amenities and a picturesque picnic area, your ideal home awaits. Explore our availability and schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Park at Tuscany, your ideal apartment community nestled in the heart of Oklahoma City, Oklahoma. With thoughtfully designed floor plans featuring one and two-bedroom layouts, we cater to diverse lifestyles and preferences. Each residence is equipped with modern conveniences, such as stainless steel appliances, spacious walk-in closets, and in-unit washer/dryer hookups, ensuring your comfort and satisfaction.\n\nOur community amenities are designed to enhance your living experience. Dive into relaxation at our stunning pool, stay active in our fully-equipped fitness center, or host gatherings in our stylish clubhouse. Need a workspace? Our business center is ready to support your professional endeavors. Enjoy peace of mind with on-site maintenance and secure gated access.\n\nStep outside to discover our beautiful sundeck, picnic area, and grill stations, perfect for enjoying sunny Oklahoma days. With plenty of storage options, vaulted ceilings, and cable-ready living spaces, you'll find everything you need right at your fingertips. Plus, the smoke-free environment and pet-friendly policies allow you to breathe easy while making Park at Tuscany feel like home.\n\nDon’t wait any longer—find your new home today! Browse our availability or schedule a tour to personally explore our vibrant community and see all that Park at Tuscany has to offer. Embrace the lifestyle you deserve and enjoy the perfect blend of comfort and convenience. Welcome home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-114e-776f-8551-73ebd683e64d.webp",
  "property_featured_image_media": {
    "alt_text": "The Tuscany apartment building's exterior with a tower at sunset.",
    "public_id": "019cfb44-114e-776f-8551-73ebd683e64d",
    "storage_key": "property/6767906449165616/019cfb44-114e-776f-8551-73ebd683e64d.webp",
    "width": 1220,
    "height": 811
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "262",
  "property_year_built": "2012",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.51145038167938",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Pets Welcome",
  "property_pet_policy_description": "Pets Welcome",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://parkattuscanyapartmentsoklahomacity.securecafe.com/onlineleasing/park-at-tuscany/floorplans.aspx",
  "property_resident_portal_url": "https://parkattuscanyapartmentsoklahomacity.securecafe.com/residentservices/park-at-tuscany/userlogin.aspx",
  "property_apply_now_url": "https://parkattuscanyapartmentsoklahomacity.securecafe.com/onlineleasing/park-at-tuscany/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a6ae-75ea-9763-a8231c524114.webp",
  "property_primary_logo_media": {
    "alt_text": "The Park at Tuscany Apartments logo",
    "public_id": "019cfb43-a6ae-75ea-9763-a8231c524114",
    "storage_key": "property/6767906449165616/019cfb43-a6ae-75ea-9763-a8231c524114.webp",
    "width": 1217,
    "height": 626
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-e94f-77ec-9694-9ecfeb2df053.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb44-e94f-77ec-9694-9ecfeb2df053",
    "storage_key": "property/6767906449165616/019cfb44-e94f-77ec-9694-9ecfeb2df053.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb45-0433-7508-89cc-a3e338dcfdf5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Park at Tuscany Apartments logo",
    "public_id": "019cfb45-0433-7508-89cc-a3e338dcfdf5",
    "storage_key": "property/6767906449165616/019cfb45-0433-7508-89cc-a3e338dcfdf5.webp",
    "width": 640,
    "height": 329
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb45-0feb-7348-86c5-33ea43d741a5.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Park at Tuscany Apartments logo",
    "public_id": "019cfb45-0feb-7348-86c5-33ea43d741a5",
    "storage_key": "property/6767906449165616/019cfb45-0feb-7348-86c5-33ea43d741a5.webp",
    "width": 640,
    "height": 329
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3e543a",
  "property_secondary_color": "#d1c7b8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#515151",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1176",
  "property_sqft_min": "789",
  "property_sqft_max": "1176",
  "property_price_range": "1089 - 1549",
  "property_price_min": "1089",
  "property_price_max": "1549",
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/theparkattuscany/posts/the-right-setting-makes-all-the-differenceand-park-at-tuscany-delivers-just-that/1422342075996833/",
  "property_instagram_url": "https://www.instagram.com/parkattuscany/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlc5zSF4csocRAKWuoJOMtyA",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/tuscany-village-apartments-oklahoma-city",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park at Tuscany",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Park at Tuscany in Oklahoma City, where modern living meets comfort. Choose from spacious one- and two-bedroom floor plans, each equipped with premium amenities like a sparkling pool, fitness center, and soothing sundeck. Elevate your lifestyle in a smoke-free community designed for relaxation and convenience.",
  "property_home_floorplans_blurb": "Welcome to Park at Tuscany in Oklahoma City, where modern living meets comfort. Our thoughtfully designed apartments feature spacious one and two-bedroom floor plans tailored to your lifestyle. Venture through our vibrant community and envision your future—browse our available homes today and find the perfect fit just for you!",
  "property_home_gallery_blurb": "At Park at Tuscany in Oklahoma City, find your ideal one or two-bedroom oasis with modern amenities, including a sparkling pool, a state-of-the-art fitness center, and serene picnic areas. Picture yourself enjoying vibrant living spaces with vaulted ceilings and spacious walk-in closets—your perfect sanctuary awaits!",
  "property_home_neighborhood_blurb": "At Park at Tuscany in Oklahoma City, experience more than just a home. Embrace a vibrant neighborhood filled with lush parks, state-of-the-art fitness centers, and cultural gems like the Edmond History Museum and Belle Isle Library. Enjoy a balanced lifestyle where community meets convenience—your new adventure starts here!",
  "property_home_reviews_blurb": "At Park at Tuscany, you'll find a small community feel that puts residents first, as one satisfied tenant puts it: \"You'll have found 'home' when you come to Park at Tuscany!\" Enjoy beautifully designed apartments, prompt maintenance, and a fantastic location near shopping and dining. Experience luxury and convenience in Oklahoma City today!",
  "property_neighborhood_blurb": "At Park at Tuscany in Oklahoma City, your lifestyle thrives in a vibrant neighborhood filled with exciting attractions. Whether it's a day at Chad Richison Stadium, a visit to the Blue Zoo Aquarium, or enjoying the serene trails at Martin Park Nature Center, your nearby adventures await. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Park at Tuscany in Oklahoma City, where luxury meets comfort. Choose from our stylish one- and two-bedroom floor plans, each brimming with modern conveniences. Dive into our refreshing pool, unwind in the clubhouse, or enjoy a meal at the picnic area. Your ideal home awaits!",
  "property_applynow_blurb": "At Park at Tuscany in Oklahoma City, your ideal retreat awaits. Choose from spacious one- and two-bedroom apartments featuring modern amenities like stainless steel appliances, walk-in closets, and cozy fireplaces. Dive into comfort with our inviting pool, fitness center, and picnic area. Lease online today for your new home!",
  "property_contactus_blurb": "At Park at Tuscany in Oklahoma City, a variety of thoughtfully designed floor plans await you, from cozy one-bedrooms to spacious two-bedrooms. Experience modern living in a vibrant community. Have questions? Our leasing team is ready to assist you—reach out today to learn more about your future home!",
  "property_faqs_blurb": "At Park at Tuscany in Oklahoma City, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Have questions? Our FAQs page provides the insights you need to make the best decision for your new home. Dive in and learn more about our vibrant community today!",
  "property_floorplans_blurb": "At Park at Tuscany in Oklahoma City, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Each apartment combines comfort and style, creating a perfect sanctuary. Browse our available homes and choose the ideal space that resonates with your vision of modern living.",
  "property_gallery_blurb": "At Park at Tuscany in Oklahoma City, picture your life enhanced by luxurious one- and two-bedroom floor plans. With a stunning pool, fitness center, and scenic sundeck, each day feels like a retreat. Embrace a smoke-free lifestyle with modern amenities that cater to your every need—your ideal home awaits!",
  "property_interactivemap_blurb": "Welcome to Park at Tuscany in Oklahoma City, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans, and indulge in top-tier amenities like a shimmering pool, fitness center, and inviting clubhouse. Use our interactive community map to unveil your perfect apartment today!",
  "property_pets_blurb": "Experience the charm of Park at Tuscany in Oklahoma City, where modern living meets tranquil surroundings. Our pet-friendly community offers spacious apartments and lush landscapes, perfect for you and your furry companions. Enjoy a serene lifestyle with easy access to city conveniences, making every day feel like a getaway.",
  "property_referafriend_blurb": "At Park at Tuscany in Oklahoma City, we embrace the art of community living with our spacious one and two-bedroom floor plans. Invite your friends to experience the comfort and camaraderie of our vibrant neighborhood. Great friends make great neighbors—refer a friend today and grow our welcoming community!",
  "property_residentaccess_blurb": "At Park at Tuscany in Oklahoma City, elevate your living experience with spacious one and two-bedroom floor plans designed for comfort and style. Access your resident portal effortlessly to manage rent payments, schedule maintenance, and enjoy hassle-free living in our vibrant community. Your new home awaits!",
  "property_reviews_blurb": "At Park at Tuscany, our residents describe their homes as \"a slice of Italy right in America's Heartland.\" With spacious floor plans, top-notch maintenance, and a friendly community atmosphere, you’ll feel an instant connection here. Unwind by the pool or explore nearby shopping and dining—your ideal lifestyle awaits!",
  "property_created_at": "1753982388181",
  "property_scheduletour_blurb": "At Park at Tuscany in Oklahoma City, choose from thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Schedule a tour today and experience the vibrant community that our residents love. Don't just take our word for it—see firsthand what makes living here truly special!",
  "property_thankyou_blurb": "Thank you for reaching out to Park at Tuscany in Oklahoma City! Our vibrant community offers a variety of thoughtfully designed one and two-bedroom floor plans, perfect for every lifestyle. A team member will connect with you shortly to help you find your ideal home sweet home.",
  "property_virtualtours_blurb": "At Park at Tuscany in Oklahoma City, spacious floor plans await, including inviting one and two-bedroom options designed for comfort and style. Immerse yourself in a virtual tour to experience our vibrant community and find your ideal home. Your perfect apartment is just a click away—explore today!",
  "property_copyright": "2025 All Rights Reserved. Park at Tuscany",
  "property_seo_title_home": "Park at Tuscany |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Discover Park at Tuscany in OKC—spacious one & two-bedroom homes, great amenities, and a vibrant community await your perfect lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Park at Tuscany in Oklahoma City! Choose from stylish one and two-bedroom floor plans. Your perfect apartment awaits!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover Park at Tuscany in OKC! Enjoy a resort-style pool, modern fitness center, and spacious apartments with upscale amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Experience life at Park at Tuscany in OKC—luxury living with stunning views, a pool, fitness center, and more. Picture yourself in your dream apartment today!",
  "property_seo_title_virtualtours": "Virtual Tours | Park at Tuscany Apartments",
  "property_seo_description_virtualtours": "Experience Park at Tuscany in Oklahoma City! Take a virtual tour of our stunning one and two-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Park at Tuscany Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Park at Tuscany, Oklahoma City! Explore our interactive map for one and two-bedroom apartments with great amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Discover vibrant living at Park at Tuscany! Explore local gems and recreation in Oklahoma City—your perfect neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Park at Tuscany",
  "property_seo_description_contact": "Connect with Park at Tuscany in Oklahoma City! Inquire about our one and two-bedroom floor plans and let our leasing team answer your questions today!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Uncover answers to your questions at Park at Tuscany! From floor plans to amenities, our FAQs guide you through life in vibrant Oklahoma City.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Experience life at Park at Tuscany in Oklahoma City! Dive into resident reviews and see why our vibrant community, pool, and chic amenities feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Elevate your lifestyle at Park at Tuscany in Oklahoma City! Enjoy spacious one- and two-bedroom apartments with resort-style amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Park at Tuscany",
  "property_seo_description_residentaccess": "Elevate your living experience at Park at Tuscany. Access your resident portal for easy rent payments, maintenance requests, and essential community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Park at Tuscany",
  "property_seo_description_referafriend": "Refer a friend to Park at Tuscany in Oklahoma City! Great friends make great neighbors—join our vibrant community and enjoy exceptional living together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Park at Tuscany",
  "property_seo_description_scheduletour": "Experience the charm of Park at Tuscany in Oklahoma City. Visit us today and see why our community is the perfect place to call home! Schedule your tour now!",
  "property_seo_title_privacy": "Privacy Policy | Park at Tuscany",
  "property_seo_description_privacy": "At Park at Tuscany in Oklahoma City, we value your privacy. Read our policy to learn how we protect your data while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Park at Tuscany",
  "property_seo_description_accessibility": "At Park at Tuscany in Oklahoma City, we prioritize digital inclusion. Our accessibility statement ensures everyone can feel at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Park at Tuscany",
  "property_seo_description_sitemap": "Navigate your way through Park at Tuscany’s offerings in Oklahoma City! Our sitemap helps you find your ideal home—efficient living tailored just for you.",
  "property_seo_title_thankyou": "Thank You | Park at Tuscany",
  "property_seo_description_thankyou": "Thank you for reaching out to Park at Tuscany in Oklahoma City! We’ll connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865510934",
  "amenities": [
    {
      "id": "custom_98c2175a-ed35-4474-ae52-383ae5a152af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck with Picnic and Barbecue Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d3f2751-2e07-4e60-8607-b70560ac7c61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1fdccc1c-e1e2-4e82-98e2-e09eaefbc4a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a467d5e1-2886-4900-ba7b-805d61c763f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Gorgeous Courtyard Grounds",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84eb632a-6992-4d9f-8334-930a573fecdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Endurance Fitness Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0fc7578-5362-4c57-8fea-be2b7c32a41c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd72fa79-0aa3-4b1a-adc6-36d44160f323",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Night Courtesy Patrol",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd8766d2-92c0-4dd6-a050-846259d452a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d7c18d7-786d-446d-8178-22f027c265c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bdd2b3f6-959d-4b4f-ac9b-d12743f8c5ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f5f6ae2-aa6c-4df6-9c30-3255c7a5e604",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c58fc3eb-a179-4447-9967-4010d183b5e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77e3e9e8-a33f-4357-9e31-894b543c560f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1cdcee10-090e-482a-9dd7-a29b3b6f42fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba4ab0a5-8d64-4975-b92e-b635d47b1838",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Tile",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5d7534f-494a-4218-93be-b0372c9bb723",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Nine‑Foot Ceilings*",
      "amount": "false",
      "description": "In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bebd55e-7fe6-4be6-a68b-807f95801658",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious and Bright Living Spaces",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f2e039fb-b21e-4726-8dc7-2bee5ab0b438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff721524-b137-4795-98b1-514ba9031487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Side‑by‑Side Refrigerator with Icemaker",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_981676bb-4fae-4597-8c0f-f220cc430e86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7db8c50e-636c-4edf-8315-af10d588cfad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_434cb5ea-8caa-42fe-a6d0-fa8cf35e5412",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2f65551-c678-42c3-bde1-3f8eea4dccb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d401ffa3-4492-499e-8123-c33f075cd50e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "external_id": "false",
      "title": "Get Connected To Super‑Fast Internet Powered By AT&T",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ac7120d3-e739-4723-a1d3-8b723778f1fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a669-704f-afc7-81edfa5b3212.webp",
      "image_media": {
        "alt_text": "Fenced dog park with a Bark Park sign at an apartment community.",
        "public_id": "019cfb43-a669-704f-afc7-81edfa5b3212",
        "storage_key": "property/6767906449165616/019cfb43-a669-704f-afc7-81edfa5b3212.webp",
        "width": 588,
        "height": 393
      },
      "title": "Community",
      "description": "Outdoor dog park amenity at the community featuring a fenced play area and Bark Park sign.",
      "link": "",
      "alt_text": "Fenced dog park with a Bark Park sign at an apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2Fd0e4081ac232d1cdc1f70ee4bae7b683.webp"
    },
    {
      "id": "custom_a72d329d-3bed-4aa4-893e-b227255332c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-42a6-720a-8a7a-670f424486c3.webp",
      "image_media": {
        "alt_text": "Exterior view of a stone-clad clubhouse with arches and a red-tiled roof at an apartment community.",
        "public_id": "019cfb44-42a6-720a-8a7a-670f424486c3",
        "storage_key": "property/6767906449165616/019cfb44-42a6-720a-8a7a-670f424486c3.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Photo of the leasing clubhouse at the community, featuring a stone façade, arches, and a red-tile roof.",
      "link": "",
      "alt_text": "Exterior view of a stone-clad clubhouse with arches and a red-tiled roof at an apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Bi9cmd9cPwnLiWfixjBW8tys_-6KO4t1V4c-u-bKYpU/102/image.jpg"
    },
    {
      "id": "custom_65890c37-ef23-43f9-85b8-e3b369387f83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a66b-74a9-98b0-4cea3dd416a1.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment complex with balconies and a parking lot.",
        "public_id": "019cfb43-a66b-74a9-98b0-4cea3dd416a1",
        "storage_key": "property/6767906449165616/019cfb43-a66b-74a9-98b0-4cea3dd416a1.webp",
        "width": 655,
        "height": 437
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with brick accents, balconies, and neatly landscaped grounds.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment complex with balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F38b2d883a0f535a89c16bb61c5cce0c8.webp"
    },
    {
      "id": "custom_697b6453-c95d-471d-adac-36ce29105545",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a668-7338-a2a3-95abc6eb209b.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-family apartment complex with row of townhome-style buildings and attached garages.",
        "public_id": "019cfb43-a668-7338-a2a3-95abc6eb209b",
        "storage_key": "property/6767906449165616/019cfb43-a668-7338-a2a3-95abc6eb209b.webp",
        "width": 712,
        "height": 475
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community featuring attached garage units and brick accents.",
      "link": "",
      "alt_text": "Exterior of a multi-family apartment complex with row of townhome-style buildings and attached garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F2487f0fb8653dc430ed2cd34414ba0c7.webp"
    },
    {
      "id": "custom_030c43e6-f699-4c96-a03f-b8e68f3a6181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a671-759f-8842-4caa8cfdb149.webp",
      "image_media": {
        "alt_text": "Community lounge with white tufted sofas, a dark fireplace, peacock artwork, and arched windows.",
        "public_id": "019cfb43-a671-759f-8842-4caa8cfdb149",
        "storage_key": "property/6767906449165616/019cfb43-a671-759f-8842-4caa8cfdb149.webp",
        "width": 775,
        "height": 517
      },
      "title": "Community",
      "description": "Bright, modern community lounge featuring a central fireplace, arched windows, and white seating with blue accents.",
      "link": "",
      "alt_text": "Community lounge with white tufted sofas, a dark fireplace, peacock artwork, and arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2Fa6ca7e4141948ef705a0a88a864357a8.webp"
    },
    {
      "id": "custom_e06f7956-1e8b-4c25-ba45-0f360cdee18c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a68e-74ac-b917-70762c3bcb24.webp",
      "image_media": {
        "alt_text": "Bright community lounge with sofas, a dining table, large arched windows, and a wall-mounted TV.",
        "public_id": "019cfb43-a68e-74ac-b917-70762c3bcb24",
        "storage_key": "property/6767906449165616/019cfb43-a68e-74ac-b917-70762c3bcb24.webp",
        "width": 682,
        "height": 455
      },
      "title": "Community",
      "description": "Spacious resident lounge featuring comfortable seating, a dining area, large windows, and a wall-mounted TV.",
      "link": "",
      "alt_text": "Bright community lounge with sofas, a dining table, large arched windows, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2Fa1e6a2d35b9d7ced853b7890904a5c9f.webp"
    },
    {
      "id": "custom_d4487293-4a22-4417-99f0-d344ab02a7b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-af6a-746f-b740-32a955a1088f.webp",
      "image_media": {
        "alt_text": "Bright fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019cfb43-af6a-746f-b740-32a955a1088f",
        "storage_key": "property/6767906449165616/019cfb43-af6a-746f-b740-32a955a1088f.webp",
        "width": 680,
        "height": 454
      },
      "title": "Community",
      "description": "Well-equipped resident gym featuring cardio machines, weight training equipment, and a spacious workout area.",
      "link": "",
      "alt_text": "Bright fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F05b82b8814496bda18118d0611a68532.webp"
    },
    {
      "id": "custom_2ffe22ad-22c0-4ec4-adc7-f8b6b04a01eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a672-75eb-ac02-5ba7a474b21a.webp",
      "image_media": {
        "alt_text": "Aerial view of a large multifamily apartment community with many buildings, parking lots, and green spaces.",
        "public_id": "019cfb43-a672-75eb-ac02-5ba7a474b21a",
        "storage_key": "property/6767906449165616/019cfb43-a672-75eb-ac02-5ba7a474b21a.webp",
        "width": 540,
        "height": 360
      },
      "title": "Community",
      "description": "Aerial overview of a large multifamily community featuring clustered apartment buildings, parking, and landscaped grounds.",
      "link": "",
      "alt_text": "Aerial view of a large multifamily apartment community with many buildings, parking lots, and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F8755af9eff6cd1d0c8b5eccaf341fb9f.webp"
    },
    {
      "id": "custom_c61d25a4-eb24-463b-b4f7-5feac9bfc52a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a671-759f-8842-482079cd6af5.webp",
      "image_media": {
        "alt_text": "Bright living/dining area with large windows, a glass round table, four grey upholstered chairs, and a wood sideboard.",
        "public_id": "019cfb43-a671-759f-8842-482079cd6af5",
        "storage_key": "property/6767906449165616/019cfb43-a671-759f-8842-482079cd6af5.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Modern apartment living space with a dining nook and neutral decor.",
      "link": "",
      "alt_text": "Bright living/dining area with large windows, a glass round table, four grey upholstered chairs, and a wood sideboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F963626f06f55e269ef0e2d4d685676a1.webp"
    },
    {
      "id": "custom_9d3decfa-61f3-4872-92ea-8569d6b1af06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-b028-71b6-bc67-29c3bfd0597c.webp",
      "image_media": {
        "alt_text": "Home office setup with a wooden desk, orange chairs, computer, and shelving.",
        "public_id": "019cfb43-b028-71b6-bc67-29c3bfd0597c",
        "storage_key": "property/6767906449165616/019cfb43-b028-71b6-bc67-29c3bfd0597c.webp",
        "width": 799,
        "height": 533
      },
      "title": "Apartment",
      "description": "Modern apartment office area with a wooden desk, computer, printer, and decorative shelving.",
      "link": "",
      "alt_text": "Home office setup with a wooden desk, orange chairs, computer, and shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F5cb12aa052d3b1e6ed9e0811affe8ec0.webp"
    },
    {
      "id": "custom_97c9b52e-2426-4419-bb6f-401cc80f7096",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-b09c-761a-93ee-5b0171690678.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a white sectional sofa, blue cushions, and a TV.",
        "public_id": "019cfb43-b09c-761a-93ee-5b0171690678",
        "storage_key": "property/6767906449165616/019cfb43-b09c-761a-93ee-5b0171690678.webp",
        "width": 828,
        "height": 552
      },
      "title": "Apartment",
      "description": "Bright, contemporary living space in an apartment featuring a white sectional, blue pillows, a TV stand, and large windows.",
      "link": "",
      "alt_text": "Living room in an apartment with a white sectional sofa, blue cushions, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F7b2f392a72bacd44e34aa6981f600242.webp"
    },
    {
      "id": "custom_67143479-975d-4ea9-a287-9bff4864f7d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d20af-511c-747f-b335-3a77619d82a3.webp",
      "image_media": {
        "alt_text": "Large white OKC monument letters on a grassy field with a ferris wheel and city skyline.",
        "public_id": "019d20af-511c-747f-b335-3a77619d82a3",
        "storage_key": "property/6767906449165616/019d20af-511c-747f-b335-3a77619d82a3.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Exterior shot of the OKC monument sign in a park, with a ferris wheel and skyline in the background.",
      "link": "",
      "alt_text": "Large white OKC monument letters on a grassy field with a ferris wheel and city skyline.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F179556509e37c516feaa8448b44e9c4b.jpg"
    },
    {
      "id": "custom_04767b6a-ffdd-4b6f-beb8-7d2902b50a3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d20af-5e90-7755-833a-cad558583272.webp",
      "image_media": {
        "alt_text": "Person holding a white travel mug beside a bicycle.",
        "public_id": "019d20af-5e90-7755-833a-cad558583272",
        "storage_key": "property/6767906449165616/019d20af-5e90-7755-833a-cad558583272.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Casual outdoor lifestyle shot of a person in a denim shirt holding a white travel mug beside a bicycle.",
      "link": "",
      "alt_text": "Person holding a white travel mug beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2F301c52f434bc61b47e662744522cd5ea.webp"
    },
    {
      "id": "custom_6ba2b08c-d222-4edf-8e1f-d2784c3a1c4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d20af-5f23-77b5-be7b-4c8427e2b8db.webp",
      "image_media": {
        "alt_text": "Children with backpacks lining up to board a yellow school bus.",
        "public_id": "019d20af-5f23-77b5-be7b-4c8427e2b8db",
        "storage_key": "property/6767906449165616/019d20af-5f23-77b5-be7b-4c8427e2b8db.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Kids with backpacks line up to board a yellow school bus, capturing a typical school-day moment near a residential community.",
      "link": "",
      "alt_text": "Children with backpacks lining up to board a yellow school bus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2Fb0bee95f570abd714e166175fc587c80.webp"
    },
    {
      "id": "custom_98a8e3a1-4733-4fc1-8885-a595d09e0e03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d20af-6810-747d-b46e-25a71b451c6b.webp",
      "image_media": {
        "alt_text": "Outdoor shopping plaza with brick storefronts, planters, and people walking.",
        "public_id": "019d20af-6810-747d-b46e-25a71b451c6b",
        "storage_key": "property/6767906449165616/019d20af-6810-747d-b46e-25a71b451c6b.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "An outdoor shopping plaza at the apartment community with storefronts, planters, and residents strolling.",
      "link": "",
      "alt_text": "Outdoor shopping plaza with brick storefronts, planters, and people walking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165616%2Fbfaeabed484fa12a5688bbfa30b49fcf.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1642faad-5260-40f3-a5c8-f037b263e143",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Entertainment venue blending technology, dining, and golf with a sports bar, and rooftop seating.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-4271-74ad-a0c4-ec6774135326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4271-74ad-a0c4-ec6774135326",
        "storage_key": "property/6767906449165616/019d2709-4271-74ad-a0c4-ec6774135326.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758d-7799-b6cf-f93f46a49e37",
        "storage_key": "property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0432ae12-f3ca-47bd-b5ea-bcb2013fec64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a fun day of pickleball, cornhole, drinks, and snacks. They also highlight the friendly staff, the perfect atmosphere for all ages, and the great experience for families and friends.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-43f7-7190-b4d4-9d8e4f7b5f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-43f7-7190-b4d4-9d8e4f7b5f47",
        "storage_key": "property/6767906449165616/019d2709-43f7-7190-b4d4-9d8e4f7b5f47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5570464",
      "poi_longitude": "-97.5088888",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758d-7799-b6cf-f93f46a49e37",
        "storage_key": "property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bb3841ee-883f-4e43-a264-9b580e078f2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "5600 N Pennsylvania Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual, upscale-casual chain for steak, pasta, pizza and burgers, plus gourmet cakes.",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and steak. They also highlight the friendly staff, generous portions, and extensive menu with options for everyone.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-42e5-71db-83a6-69d225526dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-42e5-71db-83a6-69d225526dbe",
        "storage_key": "property/6767906449165616/019d2709-42e5-71db-83a6-69d225526dbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/oklahoma-city-117.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=931265600312329473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "35.5260485",
      "poi_longitude": "-97.5471558",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-843-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758d-7799-b6cf-f93f46a49e37",
        "storage_key": "property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgc4NZkAasocRAUUoIiGF7Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bc48d276-1d86-485f-a97c-3eb7ddd81bb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of fun games, including bowling, laser tag, and arcade games, and the pizza is great. They also highlight the friendly staff, the fun atmosphere, and the good drinks.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-42d7-766b-a60f-0081ed25586d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-42d7-766b-a60f-0081ed25586d",
        "storage_key": "property/6767906449165616/019d2709-42d7-766b-a60f-0081ed25586d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758d-7799-b6cf-f93f46a49e37",
        "storage_key": "property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_94adb237-d0a9-416a-ac10-5d393bb137f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain serving steaks and ribs in a casual setting featuring a jukebox and line dancers.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and ribs, and the rolls with cinnamon butter are a highlight. They also highlight the friendly and accommodating staff, and the family-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-476d-70bc-9c9f-06c554cf2c13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-476d-70bc-9c9f-06c554cf2c13",
        "storage_key": "property/6767906449165616/019d2709-476d-70bc-9c9f-06c554cf2c13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758d-7799-b6cf-f93f46a49e37",
        "storage_key": "property/6767906449165616/019d2709-758d-7799-b6cf-f93f46a49e37.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_6aac18f6-5ce1-4196-a84a-323a47586c4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-486f-7564-bc5f-41acaa0ad8c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-486f-7564-bc5f-41acaa0ad8c8",
        "storage_key": "property/6767906449165616/019d2709-486f-7564-bc5f-41acaa0ad8c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7632-7289-828d-7e5f51d0eb8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7632-7289-828d-7e5f51d0eb8a",
        "storage_key": "property/6767906449165616/019d2709-7632-7289-828d-7e5f51d0eb8a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b1980f6c-7ec3-4efb-816f-1f7967bdc89b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain featuring organic, gluten-free and vegan options, plus wine and flowers.",
      "poi_long_description": "People say this grocery store offers a wide selection of unique items, fresh produce, organic food, snacks, and wine. They highlight the affordable prices, good quality, and convenient pre-prepared meals. They also like the friendly staff and the pleasant, welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-48bc-7635-9ea2-b1a5d1c2a471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-48bc-7635-9ea2-b1a5d1c2a471",
        "storage_key": "property/6767906449165616/019d2709-48bc-7635-9ea2-b1a5d1c2a471.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7639-70bf-908d-8416659ec063.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7639-70bf-908d-8416659ec063",
        "storage_key": "property/6767906449165616/019d2709-7639-70bf-908d-8416659ec063.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cc798eb6-7e3c-43f9-b600-8b4d3fac5a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Groceries, produce, artisan cheese and baked goods at a modern supermarket.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, cheeses, and baked goods, including many organic and vegan options. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-4907-70b2-b62a-a4a4895f8e3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4907-70b2-b62a-a4a4895f8e3f",
        "storage_key": "property/6767906449165616/019d2709-4907-70b2-b62a-a4a4895f8e3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7639-70bf-908d-8416659ec063.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7639-70bf-908d-8416659ec063",
        "storage_key": "property/6767906449165616/019d2709-7639-70bf-908d-8416659ec063.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_783e7237-c9de-44cc-984d-444e7d0467ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 W 15th St #124, Edmond, OK 73013, USA",
      "poi_short_description": "Supermarket featuring aisles of fresh groceries, baked goods and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-4c95-724c-9428-7ba5ad188cac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4c95-724c-9428-7ba5ad188cac",
        "storage_key": "property/6767906449165616/019d2709-4c95-724c-9428-7ba5ad188cac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428274884093566538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.6368691",
      "poi_longitude": "-97.5127608",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-330-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7639-70bf-908d-8416659ec063.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7639-70bf-908d-8416659ec063",
        "storage_key": "property/6767906449165616/019d2709-7639-70bf-908d-8416659ec063.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSeJIYgesocRSl4izw3214I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0f03409c-08e6-4ca5-a0ff-51199d2aea2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "The Home Depot, 1901 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Home-improvement chain offering paint, tools, and building materials, plus installation services.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist with any task. They also highlight the friendly and efficient customer service, and the clean and well-stocked store.\n\nSome reviews mention the staff can be difficult to locate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-4ccd-736e-80fc-dbf4ab508fc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4ccd-736e-80fc-dbf4ab508fc3",
        "storage_key": "property/6767906449165616/019d2709-4ccd-736e-80fc-dbf4ab508fc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Edmond/OK/Edmond/73013/3907?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451913410994265011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.6346297",
      "poi_longitude": "-97.4849931",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-330-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7632-7289-828d-7e5f51d0eb8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7632-7289-828d-7e5f51d0eb8a",
        "storage_key": "property/6767906449165616/019d2709-7632-7289-828d-7e5f51d0eb8a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9xQ7Wf4esocRs1uAoFwWqUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_26494ac4-d1dc-4178-b540-f18796aec806",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "University of Central Oklahoma",
      "poi_type": "Education",
      "poi_address": "100 N University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-4dda-72f8-a8d9-912f1a66d844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4dda-72f8-a8d9-912f1a66d844",
        "storage_key": "property/6767906449165616/019d2709-4dda-72f8-a8d9-912f1a66d844.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.uco.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296425383341636856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-central-oklahoma",
      "poi_latitude": "35.657506",
      "poi_longitude": "-97.4709491",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-974-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7648-723d-ad29-4410a1dd020b",
        "storage_key": "property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZ0xm_BNr4cR-Lwg6j4_CfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_945569c7-bc1c-4ffd-933a-39421e0f057e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-4d7b-7019-b431-35bdde75d51f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4d7b-7019-b431-35bdde75d51f",
        "storage_key": "property/6767906449165616/019d2709-4d7b-7019-b431-35bdde75d51f.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7648-723d-ad29-4410a1dd020b",
        "storage_key": "property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7a3884df-c60d-4ec9-8f06-8d9e7caa5f2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Belle Isle Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5501 N Villa Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Warm, friendly public library with a children’s area, study rooms and computers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5128-736e-92b0-a76885e13c55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5128-736e-92b0-a76885e13c55",
        "storage_key": "property/6767906449165616/019d2709-5128-736e-92b0-a76885e13c55.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12135984821329026772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belle-isle-library---metropolitan-library-system",
      "poi_latitude": "35.52557300000001",
      "poi_longitude": "-97.5569692",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-843-9601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7648-723d-ad29-4410a1dd020b",
        "storage_key": "property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWXwrG2gasocR1F7ZUuWta6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_f89c3893-9a71-40e4-9cd5-6245dbe5324e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-521f-73c5-b18f-c474c086455e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-521f-73c5-b18f-c474c086455e",
        "storage_key": "property/6767906449165616/019d2709-521f-73c5-b18f-c474c086455e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_f0054c23-d5fd-4d6e-a325-87bdfdaeb544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Sky Zone",
      "poi_type": "Entertainment",
      "poi_address": "2525 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Children's entertainment center featuring indoor trampolines and other activities such as SkySlam basketball.",
      "poi_long_description": "People say this amusement park offers a fun trampoline park experience. They also highlight the friendly staff and management, and the clean and well-maintained facilities.\n\nOther reviews mention the price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-52b1-7433-9029-025fddb9fab1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-52b1-7433-9029-025fddb9fab1",
        "storage_key": "property/6767906449165616/019d2709-52b1-7433-9029-025fddb9fab1.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.skyzone.com/edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11100529412539313541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone",
      "poi_latitude": "35.6300623",
      "poi_longitude": "-97.4862479",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-359-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75ZG2_wesocRhW0uBbAADZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_4736a5de-4978-4fd7-9a7e-3fadd09154b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Chad Richison Stadium",
      "poi_type": "Entertainment",
      "poi_address": "100 E University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "High school stadium hosting football games, including state championship events.",
      "poi_long_description": "People say this stadium offers a great experience for watching soccer games. They highlight the facilities are clean and well-maintained, and the sound system is top-notch. They also like the wide variety of concession options and the convenient credit card acceptance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5325-72a7-8b47-07009448eafb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5325-72a7-8b47-07009448eafb",
        "storage_key": "property/6767906449165616/019d2709-5325-72a7-8b47-07009448eafb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bronchosports.com/sports/2011/6/10/FB_0610111744.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132052462898693569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chad-richison-stadium",
      "poi_latitude": "35.6615051",
      "poi_longitude": "-97.4707673",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-974-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7a1c-7198-8fcf-7fbdf759781b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7a1c-7198-8fcf-7fbdf759781b",
        "storage_key": "property/6767906449165616/019d2709-7a1c-7198-8fcf-7fbdf759781b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhdKbbbcfsocRwcWyeAhInIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2ec4260a-9e49-44f8-8f6c-ac84515bc75b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Edmond History Museum",
      "poi_type": "Entertainment",
      "poi_address": "431 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of displays and hands-on activities, especially for children. They highlight the fun role-play activities and the interesting local facts for adults. They also like the friendly staff and the free admission with the option of a gift shop and donation box.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-56a1-734a-853c-19416b5e57e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-56a1-734a-853c-19416b5e57e2",
        "storage_key": "property/6767906449165616/019d2709-56a1-734a-853c-19416b5e57e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.edmondhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=107138316684570186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-history-museum",
      "poi_latitude": "35.650103",
      "poi_longitude": "-97.4784",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-340-0078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7a6d-7151-bd6c-9d3cc197caa7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7a6d-7151-bd6c-9d3cc197caa7",
        "storage_key": "property/6767906449165616/019d2709-7a6d-7151-bd6c-9d3cc197caa7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3Bcga0fsocRSi7RO7uhfAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fcb1f0f7-b511-4f8a-9a41-08942243c625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Dobson Field",
      "poi_type": "Entertainment",
      "poi_address": "Baird Loop, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5732-73af-b9bf-a3427281f5d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5732-73af-b9bf-a3427281f5d8",
        "storage_key": "property/6767906449165616/019d2709-5732-73af-b9bf-a3427281f5d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9132438859912438972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dobson-field",
      "poi_latitude": "35.6139766",
      "poi_longitude": "-97.4731539",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7a1c-7198-8fcf-7fbdf759781b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7a1c-7198-8fcf-7fbdf759781b",
        "storage_key": "property/6767906449165616/019d2709-7a1c-7198-8fcf-7fbdf759781b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn_Ha_3IfsocRvOQN4sHwvH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_db374847-c293-493e-b041-5b323b8cd3be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Mitch Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Marilyn Williams Dr, Edmond, OK 73003, USA",
      "poi_short_description": "Clean sports facility featuring a fitness center and an outdoor track, as well as an indoor pool, disc golf and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5850-76fc-82b4-9583d020598d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5850-76fc-82b4-9583d020598d",
        "storage_key": "property/6767906449165616/019d2709-5850-76fc-82b4-9583d020598d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcaokc.org/branches/mitch-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15994863836961186949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park-ymca",
      "poi_latitude": "35.6847017",
      "poi_longitude": "-97.5083114",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-330-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eeHJvT1sYcRhSTQUOor-d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ef1171ae-11da-44d8-a550-c6138420d2ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5802-7148-8c61-f7c5abc27f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5802-7148-8c61-f7c5abc27f00",
        "storage_key": "property/6767906449165616/019d2709-5802-7148-8c61-f7c5abc27f00.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5b5330cc-a975-4a90-a6a9-d332d59b8dca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5bd5-7339-bb11-aa2d914c18a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5bd5-7339-bb11-aa2d914c18a7",
        "storage_key": "property/6767906449165616/019d2709-5bd5-7339-bb11-aa2d914c18a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7eacb38d-0d64-4435-ae60-7d17c41f1ff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers fun classes and birthday parties for young children. They highlight the positive and encouraging atmosphere, and the confidence children gain. They also like the kind, welcoming, and dedicated staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5c58-70cd-9180-86ce7c0aca21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5c58-70cd-9180-86ce7c0aca21",
        "storage_key": "property/6767906449165616/019d2709-5c58-70cd-9180-86ce7c0aca21.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7648-723d-ad29-4410a1dd020b",
        "storage_key": "property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_df33eb93-901e-49cf-9045-a0ea06674e5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and powerlifting stations, and has a spacious layout with an outdoor workout area.\n\nOther reviews mention the restrooms can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5d6f-7628-9d45-388593fc429e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5d6f-7628-9d45-388593fc429e",
        "storage_key": "property/6767906449165616/019d2709-5d6f-7628-9d45-388593fc429e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_27043e4d-de95-40af-91fd-1ec690131573",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2209 W Edmond Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Laid-back fitness center featuring workout machines plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a good selection of equipment and machines, including free weights and tanning beds. They highlight the clean and tidy facility, and the convenient location and hours. They also like the friendly and helpful staff, and the welcoming and non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-5d9c-734a-8145-9e4da3d0337c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5d9c-734a-8145-9e4da3d0337c",
        "storage_key": "property/6767906449165616/019d2709-5d9c-734a-8145-9e4da3d0337c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/edmond-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798186502624872755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6543154",
      "poi_longitude": "-97.5129943",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-697-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4H7420esocRM4knAtFKnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dfcd3251-e12b-43f3-9c12-42a730f9bcc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6157-72a3-960f-7ebdd0f6f285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6157-72a3-960f-7ebdd0f6f285",
        "storage_key": "property/6767906449165616/019d2709-6157-72a3-960f-7ebdd0f6f285.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e635928c-ce97-440f-938e-789b12b5650a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6092-76d8-a12f-e6a6c9087a1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6092-76d8-a12f-e6a6c9087a1e",
        "storage_key": "property/6767906449165616/019d2709-6092-76d8-a12f-e6a6c9087a1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7648-723d-ad29-4410a1dd020b",
        "storage_key": "property/6767906449165616/019d2709-7648-723d-ad29-4410a1dd020b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1a0b2b57-8622-4fe2-8343-41a4fc5ab2ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2340 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Beauty retailer offering cosmetics, fragrances, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6163-7638-a2d7-a2e98f9a6d27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6163-7638-a2d7-a2e98f9a6d27",
        "storage_key": "property/6767906449165616/019d2709-6163-7638-a2d7-a2e98f9a6d27.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751417342740012859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.606929",
      "poi_longitude": "-97.553605",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-302-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaQHR2kcsocROx-6rQW0WfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_edafe234-c610-4e18-bb3e-6dab9e043d17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-62b0-744b-a11c-ea998ceef992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-62b0-744b-a11c-ea998ceef992",
        "storage_key": "property/6767906449165616/019d2709-62b0-744b-a11c-ea998ceef992.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7a69-7284-b08f-2bd557165da4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7a69-7284-b08f-2bd557165da4",
        "storage_key": "property/6767906449165616/019d2709-7a69-7284-b08f-2bd557165da4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d27ef042-9c2d-451e-ae49-f6c569cac2c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-65b4-762f-850a-7a3f978d6548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-65b4-762f-850a-7a3f978d6548",
        "storage_key": "property/6767906449165616/019d2709-65b4-762f-850a-7a3f978d6548.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7a69-7284-b08f-2bd557165da4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7a69-7284-b08f-2bd557165da4",
        "storage_key": "property/6767906449165616/019d2709-7a69-7284-b08f-2bd557165da4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_79f97f70-8e1f-4b77-aa91-04fe3cb5f809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6625-7739-8187-5d70ce533fef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6625-7739-8187-5d70ce533fef",
        "storage_key": "property/6767906449165616/019d2709-6625-7739-8187-5d70ce533fef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d21-772c-93dc-abf5cf6f7214",
        "storage_key": "property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_262fce20-388e-4c00-a34c-74499ad50d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-66ae-7787-8436-1107362f0a07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-66ae-7787-8436-1107362f0a07",
        "storage_key": "property/6767906449165616/019d2709-66ae-7787-8436-1107362f0a07.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d21-772c-93dc-abf5cf6f7214",
        "storage_key": "property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_879d5669-b428-42b3-b38b-acde01d2a32a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-677e-766b-a897-b89a421b60be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-677e-766b-a897-b89a421b60be",
        "storage_key": "property/6767906449165616/019d2709-677e-766b-a897-b89a421b60be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d21-772c-93dc-abf5cf6f7214",
        "storage_key": "property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cf14d258-96ed-47c1-8f12-3fed6acf6bb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6aa8-752d-8d95-5b1c0f59afd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6aa8-752d-8d95-5b1c0f59afd9",
        "storage_key": "property/6767906449165616/019d2709-6aa8-752d-8d95-5b1c0f59afd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7e24-72a9-bb14-e8c0abaf8616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7e24-72a9-bb14-e8c0abaf8616",
        "storage_key": "property/6767906449165616/019d2709-7e24-72a9-bb14-e8c0abaf8616.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_8bc830ef-4c8a-4e1d-86f5-b1508e115287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Mitch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6b46-702c-8959-425eea2f0b6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6b46-702c-8959-425eea2f0b6a",
        "storage_key": "property/6767906449165616/019d2709-6b46-702c-8959-425eea2f0b6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edmondok.gov/facilities/facility/details/Mitch-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=1740714302256427325&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park",
      "poi_latitude": "35.6826377",
      "poi_longitude": "-97.5065914",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d21-772c-93dc-abf5cf6f7214",
        "storage_key": "property/6767906449165616/019d2709-7d21-772c-93dc-abf5cf6f7214.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfU7CegD1sYcRPbFvaW9CKBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e23356bd-a235-41a3-9075-f6daa9dab3c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6cb1-7328-8bea-2b2dfd174830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6cb1-7328-8bea-2b2dfd174830",
        "storage_key": "property/6767906449165616/019d2709-6cb1-7328-8bea-2b2dfd174830.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6a494cd0-60ac-40f0-a0b1-43961ccc8a57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6cab-7619-affc-5b49708e46d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6cab-7619-affc-5b49708e46d9",
        "storage_key": "property/6767906449165616/019d2709-6cab-7619-affc-5b49708e46d9.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5f057ddd-4ce2-47d4-95ba-1715dba02549",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-6f92-77bd-8f0b-eff04db317f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6f92-77bd-8f0b-eff04db317f3",
        "storage_key": "property/6767906449165616/019d2709-6f92-77bd-8f0b-eff04db317f3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6b7d34b1-ab97-4bf5-9f35-5ae3e67a61e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7130-709b-9c31-c4901cefbdcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7130-709b-9c31-c4901cefbdcf",
        "storage_key": "property/6767906449165616/019d2709-7130-709b-9c31-c4901cefbdcf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_71946f58-b490-4e2b-b340-2164b1d188e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Love's Corporate - Contact Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 W Memorial Rd Suite 100, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-710d-758b-a24b-17b6a00b4951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-710d-758b-a24b-17b6a00b4951",
        "storage_key": "property/6767906449165616/019d2709-710d-758b-a24b-17b6a00b4951.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980310977560095404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---contact-center",
      "poi_latitude": "35.61081310000001",
      "poi_longitude": "-97.5351028",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7954-750e-be50-56a4cadc991b",
        "storage_key": "property/6767906449165616/019d2709-7954-750e-be50-56a4cadc991b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbub2xkcsocRrKpygHKeHUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e2443a6c-c0ff-484c-b13e-eddca58ecc7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Summit Middle School",
      "poi_type": "Education",
      "poi_address": "1703 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-c120-77a0-8014-849f1c98c2ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c120-77a0-8014-849f1c98c2ab",
        "storage_key": "property/6767906449165616/019d7912-c120-77a0-8014-849f1c98c2ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://summit.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052681169359623432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-middle-school",
      "poi_latitude": "35.625296",
      "poi_longitude": "-97.5414836",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-340-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a5a-7240-9d85-9b28d789d82b",
        "storage_key": "property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueUCwjkcsocRCFWYLw0EPjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eb5acb8e-3761-42c1-925e-23caf525c557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Edmond Santa Fe High School",
      "poi_type": "Education",
      "poi_address": "1901 W 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-c27b-754e-b337-7b9f9f23c413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c27b-754e-b337-7b9f9f23c413",
        "storage_key": "property/6767906449165616/019d7912-c27b-754e-b337-7b9f9f23c413.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://santafe.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158354544559100067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-santa-fe-high-school",
      "poi_latitude": "35.6401779",
      "poi_longitude": "-97.5088169",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-340-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a5a-7240-9d85-9b28d789d82b",
        "storage_key": "property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPS_GbGIesocRo5Avf7m61Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_00492ba1-dc31-4ba0-a809-16b9786787e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Oklahoma School of Science and Mathematics",
      "poi_type": "Education",
      "poi_address": "1141 N Lincoln Blvd, Oklahoma City, OK 73104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-c41e-7709-a044-179a64e42a3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c41e-7709-a044-179a64e42a3e",
        "storage_key": "property/6767906449165616/019d7912-c41e-7709-a044-179a64e42a3e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ossm.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798167282039383181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-school-of-science-and-mathematics",
      "poi_latitude": "35.4786644",
      "poi_longitude": "-97.5057992",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-521-6436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a5a-7240-9d85-9b28d789d82b",
        "storage_key": "property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8XHl0D0XsocRjeSj8R_xV14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5d89317f-4347-4d4e-a8c1-aaa88bcb03b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Dove Science Academy - High School OKC",
      "poi_type": "Education",
      "poi_address": "5601 Northwest Expy, Warr Acres, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-c172-75c8-84b5-b0d0bc375fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c172-75c8-84b5-b0d0bc375fd1",
        "storage_key": "property/6767906449165616/019d7912-c172-75c8-84b5-b0d0bc375fd1.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.dsaokc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16553116476273055865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-science-academy-high-school-okc",
      "poi_latitude": "35.54825350000001",
      "poi_longitude": "-97.6132621",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-524-9762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a5a-7240-9d85-9b28d789d82b",
        "storage_key": "property/6767906449165616/019cfb44-0a5a-7240-9d85-9b28d789d82b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4XznZbIQsocRedjrpbt7uOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_880c108f-ac79-48a7-adcf-58d9012c95b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Chefs Di Domani",
      "poi_type": "Restaurants",
      "poi_address": "2727 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Upscale, adventurous cuisine & wine at a restaurant operated by Platt College culinary students.",
      "poi_long_description": "Upscale, adventurous cuisine & wine at a restaurant operated by Platt College culinary students.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-ca3e-76fc-a6b4-78677dfa3a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ca3e-76fc-a6b4-78677dfa3a49",
        "storage_key": "property/6767906449165616/019d7912-ca3e-76fc-a6b4-78677dfa3a49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4978954630398945938&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chefs-di-domani",
      "poi_latitude": "35.6110232",
      "poi_longitude": "-97.5637318",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a4a-7751-b6e8-76ffa58e94c8",
        "storage_key": "property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwZXwWAcsocRkiq3UdvMGEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_c360ab00-84ee-42b5-bf31-5ee5e29a5b52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5950 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with a variety of toppings and crust options, as well as appetizers like garlic knots and fried mushrooms. They highlight the fun, nostalgic atmosphere and the reasonable prices. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-cb1e-7628-824b-c0f175a11a06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cb1e-7628-824b-c0f175a11a06",
        "storage_key": "property/6767906449165616/019d7912-cb1e-7628-824b-c0f175a11a06.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7905621766239886332&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "35.6080676",
      "poi_longitude": "-97.6240676",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-470-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a4a-7751-b6e8-76ffa58e94c8",
        "storage_key": "property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYspIEgDsocR_BtTURxptm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_77221382-0094-41de-9785-b157d7c5436f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Neighborhood JAM",
      "poi_type": "Restaurants",
      "poi_address": "15124 Lleytons Ct #103, Edmond, OK 73013, USA",
      "poi_short_description": "Breakfast specialist serving innovative American plates, plus lunch, in a laid-back, modern space.",
      "poi_long_description": "People say this breakfast restaurant serves delicious avocado toast, El Jefe, and blueberry pancakes. They highlight the generous portions, fresh ingredients, and tasty jams. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-d4fb-7118-b7fc-d583b488b1ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d4fb-7118-b7fc-d583b488b1ef",
        "storage_key": "property/6767906449165616/019d7912-d4fb-7118-b7fc-d583b488b1ef.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://thatsmyjamokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14580118050323494136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "neighborhood-jam",
      "poi_latitude": "35.62470020000001",
      "poi_longitude": "-97.551164",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-242-4161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a4a-7751-b6e8-76ffa58e94c8",
        "storage_key": "property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpd_WrUgcsocR-PTKNB78Vso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e38b5315-595e-4920-8bc7-c4ad3fa2c816",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Interurban Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1301 E Danforth Rd, Edmond, OK 73034, USA",
      "poi_short_description": "Regional, family-friendly restaurant chain with classic American eats, a laid-back vibe & full bar.",
      "poi_long_description": "People say this bar and grill serves delicious burgers, salmon, and chicken fried steak. They also highlight the reasonable prices, friendly staff, and welcoming atmosphere.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-d431-725e-bb30-16366d0137a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d431-725e-bb30-16366d0137a6",
        "storage_key": "property/6767906449165616/019d7912-d431-725e-bb30-16366d0137a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.interurban.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=717966786918954540&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "interurban-restaurant",
      "poi_latitude": "35.6683333",
      "poi_longitude": "-97.4627778",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-348-2792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-fa9e-7402-a854-39ee4347c79b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-fa9e-7402-a854-39ee4347c79b",
        "storage_key": "property/6767906449165616/019d7912-fa9e-7402-a854-39ee4347c79b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJecSNZMEfsocRLDbVHv269gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_47820e35-f537-4bfc-9f8e-62dc910f410d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Panang 2 Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "14101 N May Ave #109, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Unfussy, family-owned option for hearty portions of familiar fare such as curries & stir-fries.",
      "poi_long_description": "People say this Thai restaurant serves delicious lunch specials with ample portions. They also highlight the fast service and friendly staff.\n\nOther reviews mention the food can be spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-d9e9-718e-9a9a-198fd4fe3f70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d9e9-718e-9a9a-198fd4fe3f70",
        "storage_key": "property/6767906449165616/019d7912-d9e9-718e-9a9a-198fd4fe3f70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://panangthaifood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9789529750388181657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panang-2-thai-restaurant",
      "poi_latitude": "35.614502",
      "poi_longitude": "-97.56789",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-752-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a4a-7751-b6e8-76ffa58e94c8",
        "storage_key": "property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH78eiV8csocRmYoB2nBl24c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_59ea09d3-abf6-493c-a8c1-5124d6ec43ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5608 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this restaurant serves delicious entrees and desserts, including a popular coconut pie. They highlight the reasonable prices and quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-de5e-7501-9a83-5ec5eacbdbdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-de5e-7501-9a83-5ec5eacbdbdb",
        "storage_key": "property/6767906449165616/019d7912-de5e-7501-9a83-5ec5eacbdbdb.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-okc-memorial/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17583160907117921524&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "35.608317",
      "poi_longitude": "-97.6174085",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-470-8169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a4a-7751-b6e8-76ffa58e94c8",
        "storage_key": "property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTyr_UkDsocR9IRMea_vA_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ae0612dc-281f-4ae8-b211-8b34a58812b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Abel's Méxican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5822 NW 50th St, Warr Acres, OK 73122, USA",
      "poi_short_description": "Basic Tex-Mex dishes, along with traditional Mexican fare, are the draw at this colorful taqueria.",
      "poi_long_description": "People say this Mexican restaurant serves flavorful Tex-Mex food with generous portions and a variety of homemade salsas. They also highlight the friendly staff, comfortable atmosphere, and good value.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-e05a-706a-9738-fc1a9864248f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e05a-706a-9738-fc1a9864248f",
        "storage_key": "property/6767906449165616/019d7912-e05a-706a-9738-fc1a9864248f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://abelsmexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1938917354506844673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "abel-s-m-xican-restaurant",
      "poi_latitude": "35.52193159999999",
      "poi_longitude": "-97.6170145",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-491-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a4a-7751-b6e8-76ffa58e94c8",
        "storage_key": "property/6767906449165616/019cfb44-0a4a-7751-b6e8-76ffa58e94c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDb2wHDYFsocRAXo4pA9r6Bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_dce2ad01-8745-4ebd-b79b-7e4e51607e63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "Lake Hefner, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5400634991969834440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-hefner",
      "poi_latitude": "35.5769492",
      "poi_longitude": "-97.5768652",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a53-722b-a2e6-bbd960a21bab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a53-722b-a2e6-bbd960a21bab",
        "storage_key": "property/6767906449165616/019cfb44-0a53-722b-a2e6-bbd960a21bab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXY-RLXIbsocRyBXoUeno8ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5ce8ef3-ee7d-4925-95fe-f61b5cad787e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "poi_name": "SoccerCity of Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "4520 Old Farm Rd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Indoor soccer facility featuring leagues and camps, plus a concession stand.",
      "poi_long_description": "People say this soccer club offers indoor soccer leagues and kids' classes and summer camps. They also highlight the affordable prices and the fun atmosphere for kids.\n\nSome reviews mention the referees can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019d7912-e290-72eb-b629-c345d58d0b0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e290-72eb-b629-c345d58d0b0a",
        "storage_key": "property/6767906449165616/019d7912-e290-72eb-b629-c345d58d0b0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soccercityokcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15448270780678546330&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "soccercity-of-oklahoma-city",
      "poi_latitude": "35.5916331",
      "poi_longitude": "-97.6055532",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-748-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-0a53-722b-a2e6-bbd960a21bab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-0a53-722b-a2e6-bbd960a21bab",
        "storage_key": "property/6767906449165616/019cfb44-0a53-722b-a2e6-bbd960a21bab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0B_cakcsocRmiNkNG1IY9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2464df16e449905e37a6625c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f5a0392f5bdac064211583d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c11cdd3e6b027d834d121d80",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0dd6d887447ba81e13cfaaee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_693589532afdd985797a8a19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_90c874e7cb29a09edf155352",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_d8d0921e-be8c-4ebe-8242-4273e3a6f055",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "rating": "5.0",
      "name": "Rick Snodgrass",
      "text": "Besides being older than most, I have been privileged to have spent the past 3 years at Park at Tuscany.  I have met many great members of our PAT community.  The leasing office are filled with amazing members who are here to help and assist you.\nThe diversity is great and I respect all cultural differences as a chance to become friends from all over the world.\nI have been dubbed the grill master and enjoy the pool when open as well as the very new gym equipment (give it a try)!\nI do not regret my decision to move in three years ago and I hope your experiences will only be better than mine when you become a member of PAT!",
      "date": "2025-08-28",
      "title": ""
    },
    {
      "id": "custom_e3eab5ff-f511-490e-9486-d48198237ea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "rating": "5.0",
      "name": "Jennifer Farrell",
      "text": "Beautiful community and office staff is always friendly and helpful. Maintenance issues are always dealt with quickly and efficiently!",
      "date": "2025-08-29",
      "title": ""
    },
    {
      "id": "custom_54e75de5-c1c0-43c5-99b2-1bf9a993b98e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "rating": "5.0",
      "name": "Joshua Mora",
      "text": "There is something magical about this place. From the moment my sister and I came into the office it felt like home. Margot and Felicia are sincere and friendly and quick to answer the many questions I had when we first moved in. The space is dog friendly with a quaint dog park in the back. The neighbors I've met so far are wonderful. I love it!",
      "date": "2024-08-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3ebd7dbc-712a-45fd-9c2a-8222d42a6754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-c68a-75f2-8e9b-08f1116a16af.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of swimming pool and apartment complex exterior",
        "public_id": "019cfb44-c68a-75f2-8e9b-08f1116a16af",
        "storage_key": "property/6767906449165616/019cfb44-c68a-75f2-8e9b-08f1116a16af.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Park at Tuscany Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff8623a8d3aa60094bfa17"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-b6d6-72cb-8144-ccd8a4d0a4c0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "park-at-tuscany",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616"
    },
    {
      "lead_collector_id": "019cf79d-b74a-716e-b9a1-98f2bc116fce",
      "lead_source": "LANDING_PAGE",
      "name": "park-at-tuscany",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-oklahoma-city",
      "search_query": "luxury apartments with pool Oklahoma City",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Discover luxury apartments with pool amenities in the heart of Oklahoma City. Experience the perfect blend of style and comfort at Park at Tuscany.",
      "page_copy": "Discover the epitome of upscale living at Park at Tuscany, offering luxury apartments with a pool in Oklahoma City. With elegantly designed one and two-bedroom floor plans, our community provides an exceptional living experience. Each apartment features modern amenities, including stainless steel appliances and vaulted ceilings, ensuring you enjoy both style and functionality. Whether you are soaking in the sunlit pool or socializing in the clubhouse, Park at Tuscany is where luxury meets community living.\n\nNestled in Northwest Oklahoma City, our property is more than just a home; it's a lifestyle. Engage in a healthy routine at our fully equipped fitness center or unwind in the serene picnic areas. Our luxury apartments with a pool create the perfect environment for relaxation and entertainment. Come and explore Park at Tuscany today and see why it's the premier choice for those seeking luxury living in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool - OKC",
      "seo_description": "Explore luxury apartments with pool amenities at Park at Tuscany, Oklahoma City. Experience modern elegance and community living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-northwest-oklahoma-city",
      "search_query": "apartments with fitness center in Northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in NW OKC",
      "h2_subtitle": "Explore top-tier apartments with a fitness center in Northwest Oklahoma City. Park at Tuscany offers modern living with premium amenities.",
      "page_copy": "Park at Tuscany features premier apartments with a fitness center, located in Northwest Oklahoma City. Our community combines the comforts of home with convenient amenities, including a state-of-the-art fitness facility, perfect for residents who prioritize an active lifestyle. Choose from our spacious one and two-bedroom floor plans, outfitted with modern finishes like stainless steel appliances and vaulted ceilings.\n\nPositioned in a vibrant neighborhood, Park at Tuscany goes beyond just offering apartments; it provides a community experience. Residents enjoy access to a sunlit pool and serene picnic areas, promoting a balanced routine of health and leisure. The on-site clubhouse serves as a hub for social events, ensuring you feel connected and engaged. Visit Park at Tuscany today and discover why our apartments with a fitness center are the ideal choice for life in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center - NW OKC",
      "seo_description": "Discover apartments with a fitness center in NW Oklahoma City. Park at Tuscany offers spacious floor plans and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "gated-apartments-with-air-conditioning-okc",
      "search_query": "gated apartments with air conditioning OKC",
      "category": "Amenity",
      "h1_title": "Gated Apartments with A/C in OKC",
      "h2_subtitle": "Find gated apartments with air conditioning in OKC. Experience comfort and security at Park at Tuscany, where luxury meets convenience.",
      "page_copy": "Welcome to Park at Tuscany, where gated apartments with air conditioning in OKC offer the ideal blend of luxury and comfort. Each one and two-bedroom apartment is meticulously designed, featuring modern amenities that include stainless steel appliances and vaulted ceilings, ensuring a relaxed living environment. While our serene setting offers respite, it's the secure, gated community that adds peace of mind for our residents.\n\nLocated in Northwest Oklahoma City, Park at Tuscany is more than just a place to live. Our community is equipped with a sunlit pool, a well-appointed fitness center, and relaxing picnic areas, making it easy for residents to balance leisure and lifestyle. Experience the difference and indulge in a community that offers both security and style. Discover why Park at Tuscany is the top choice for those seeking gated apartments with air conditioning in the heart of Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Apts with A/C - OKC",
      "seo_description": "Discover gated apartments with air conditioning in OKC. Experience luxury and comfort at Park at Tuscany in Northwest Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-hookups-oklahoma-city",
      "search_query": "apartments with in-unit laundry hookups Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apts with In-Unit Laundry Hookups in OKC",
      "h2_subtitle": "Discover apartments with in-unit laundry hookups in Oklahoma City. Park at Tuscany offers modern living with convenient amenities.",
      "page_copy": "At Park at Tuscany, we provide apartments with in-unit laundry hookups in Oklahoma City, elevating your daily living experience with convenience and comfort. Choose from our spacious one and two-bedroom floor plans, each designed with contemporary amenities such as stainless steel appliances and vaulted ceilings, all in a vibrant community setting. In-unit laundry hookups make laundry days easy and stress-free, allowing you more time to enjoy life.\n\nLocated in Northwest Oklahoma City, our community offers more than just apartments; it offers a lifestyle. Residents appreciate our on-site amenities, including a sunlit pool, fitness center, and serene picnic areas, which make it easy to unwind and connect with neighbors. Experience modern living at its finest and see why Park at Tuscany is the ideal choice for those seeking apartments with in-unit laundry hookups. Visit us today and make laundry days a breeze!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with In-Unit Laundry in OKC",
      "seo_description": "Find apartments with in-unit laundry hookups in Oklahoma City. Discover convenient living at Park at Tuscany with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "clubhouse-apartments-near-73134",
      "search_query": "clubhouse apartments near 73134",
      "category": "Amenity",
      "h1_title": "Clubhouse Apartments Near 73134",
      "h2_subtitle": "Discover clubhouse apartments near 73134 that offer the perfect blend of community and convenience. Park at Tuscany awaits you.",
      "page_copy": "Park at Tuscany offers premier clubhouse apartments near 73134, designed to foster a vibrant community atmosphere while providing the comfort of home. Our one and two-bedroom floor plans include contemporary features such as stainless steel appliances and vaulted ceilings, ensuring that each apartment meets your lifestyle needs. The centrally located clubhouse serves as the heart of our community, a perfect spot for hosting events and getting to know your neighbors.\n\nLocated in Northwest Oklahoma City, Park at Tuscany offers more than just a place to live. Our residents enjoy access to various amenities including a delightful sunlit pool and serene picnic areas. The fitness center equips residents to maintain an active lifestyle without leaving the community. Experience the unique combination of social interaction and personal relaxation—visit Park at Tuscany today and explore why our clubhouse apartments are the best choice near the 73134 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse Apartments - Near 73134",
      "seo_description": "Find clubhouse apartments near 73134 at Park at Tuscany. Enjoy community-centric living with modern amenities in Northwest Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-northwest-oklahoma-city",
      "search_query": "one bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in NW OKC",
      "h2_subtitle": "Explore one bedroom apartments in Northwest Oklahoma City. At Park at Tuscany, enjoy modern amenities and a vibrant community environment.",
      "page_copy": "Discover the perfect one bedroom apartments in Northwest Oklahoma City at Park at Tuscany, where modern living meets a welcoming community atmosphere. Each of our thoughtfully designed one-bedroom units features contemporary comforts such as stainless steel appliances, vaulted ceilings, and washer/dryer hookups. With spacious layouts, these apartments are perfect for anyone seeking comfort and style in their new home.\n\nSituated in the heart of Northwest Oklahoma City, Park at Tuscany offers more than just a place to live. Our residents enjoy exclusive access to community amenities that include a clubhouse, sunlit pool, and well-equipped fitness center. Whether you prefer relaxing by the pool or hosting a picnic in our peaceful outdoor areas, you'll find plenty of opportunities to unwind and connect with neighbors. Come and experience the best in one bedroom apartment living at Park at Tuscany.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in NW OKC",
      "seo_description": "Park at Tuscany offers one bedroom apartments in Northwest Oklahoma City with modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-73134",
      "search_query": "two bedroom apartments near 73134",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 73134",
      "h2_subtitle": "Find spacious two bedroom apartments near 73134. Park at Tuscany offers modern amenities in an ideal location.",
      "page_copy": "Discover the spacious two bedroom apartments near 73134 at Park at Tuscany, where thoughtfully designed homes offer both comfort and style. Each apartment features modern amenities including stainless steel appliances, vaulted ceilings, and in-unit laundry hookups, ensuring your living experience is as convenient as it is luxurious. These well-planned layouts provide ample space for families, professionals, or anyone in need of extra room.\n\nLocated in Northwest Oklahoma City, Park at Tuscany provides more than just expansive two-bedroom apartments. Our community is enriched with engaging amenities such as a sunlit pool, a welcoming clubhouse, and a modern fitness center. Spend your weekends relaxing by the pool or enjoying a picnic in our beautifully landscaped outdoor areas. Experience quality living near the 73134 area and see why Park at Tuscany should be your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 73134",
      "seo_description": "Explore two bedroom apartments near 73134 at Park at Tuscany, offering spacious living and modern amenities in NW Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-central-oklahoma",
      "search_query": "apartments near university of central oklahoma",
      "category": "School",
      "h1_title": "Apartments Near University of Central Oklahoma",
      "h2_subtitle": "Looking for apartments near the University of Central Oklahoma? Park at Tuscany offers convenient living close to campus in a vibrant community.",
      "page_copy": "Park at Tuscany presents an ideal choice for those seeking apartments near the University of Central Oklahoma, combining the convenience of proximity with a suite of modern amenities. Situated in Northwest Oklahoma City, our property offers easy access to campus life while providing a comfortable and serene living environment. With options for spacious one and two-bedroom apartments, each home features stainless steel appliances, vaulted ceilings, and washer/dryer hookups, perfect for students or faculty members looking for a place to call home.\n\nBeyond the individual living spaces, Park at Tuscany enhances your experience with community-centered amenities including a sunlit pool, a well-equipped fitness center, and a welcoming clubhouse. Enjoy the vibrant community atmosphere with serene picnic areas ideal for studying or relaxing. Whether you're a student seeking convenience or a faculty member wanting a peaceful retreat, our apartments deliver the perfect blend of location and lifestyle benefits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Central Oklahoma",
      "seo_description": "Find apartments near the University of Central Oklahoma at Park at Tuscany, offering modern living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-close-to-oklahoma-christian-university",
      "search_query": "oklahoma city apartments close to oklahoma christian university",
      "category": "School",
      "h1_title": "OKC Apartments Close to Oklahoma Christian Univ.",
      "h2_subtitle": "Explore Oklahoma City apartments close to Oklahoma Christian University. Park at Tuscany offers modern living with easy access to campus facilities.",
      "page_copy": "If you're searching for Oklahoma City apartments close to Oklahoma Christian University, look no further than Park at Tuscany. Located in Northwest Oklahoma City, our community offers the perfect blend of comfort, convenience, and style, ensuring that your living experience complements your academic journey. With options for spacious one and two-bedroom floor plans, you’ll find modern amenities such as stainless steel appliances, vaulted ceilings, and washer/dryer hookups in every unit.\n\nOur residents enjoy more than just well-designed living spaces. Park at Tuscany provides a range of community amenities, including a refreshing pool, a state-of-the-art fitness center, and a cozy clubhouse. Whether you're taking a break from studies or enjoying a leisurely weekend, our serene picnic areas and inviting common spaces provide the perfect backdrop. With its ideal location and vibrant community life, Park at Tuscany is the perfect home base for students and faculty of Oklahoma Christian University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments Near Oklahoma Christian University",
      "seo_description": "Discover OKC apartments close to Oklahoma Christian University at Park at Tuscany, featuring modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-close-to-mercy-hospital-oklahoma-city",
      "search_query": "apartments close to Mercy Hospital Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apartments Close to Mercy Hospital OKC",
      "h2_subtitle": "Searching for apartments close to Mercy Hospital Oklahoma City? Park at Tuscany offers comfort and convenience in a prime location.",
      "page_copy": "Choose Park at Tuscany if you are looking for apartments close to Mercy Hospital Oklahoma City, offering both tranquility and a convenient location. Residing in Northwest Oklahoma City, our apartments make it easy for healthcare professionals and their families to enjoy short commutes, leaving more time to enjoy life's pleasures. Experience spacious one and two-bedroom apartments with modern features like stainless steel appliances, vaulted ceilings, and washer/dryer hookups in every unit.\n\nThe benefits of living at Park at Tuscany extend beyond your apartment’s interior. Our community is equipped with a sunlit pool, a well-fitted fitness center, and a welcoming clubhouse, enhancing your quality of life. Unwind after a day at work near our serene picnic areas, or socialize with neighbors to balance a busy schedule. With close proximity to Mercy Hospital and a host of lifestyle amenities, Park at Tuscany meets both professional needs and personal comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Mercy Hospital Oklahoma City",
      "seo_description": "Discover apartments close to Mercy Hospital OKC at Park at Tuscany, featuring spacious layouts and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "park-at-tuscany-near-integris-health-baptist-medical-center",
      "search_query": "Park at Tuscany near INTEGRIS Health Baptist Medical Center",
      "category": "Hospital",
      "h1_title": "Park at Tuscany Near INTEGRIS Baptist Medical",
      "h2_subtitle": "Experience the convenience of Park at Tuscany near INTEGRIS Health Baptist Medical Center. Enjoy modern living just minutes from work.",
      "page_copy": "Welcome to Park at Tuscany, ideally located near INTEGRIS Health Baptist Medical Center in Northwest Oklahoma City. Our community provides an excellent option for healthcare professionals seeking convenience and comfort, with the medical center just a short commute away. Choose from our spacious one and two-bedroom apartments that boast modern amenities, including stainless steel appliances, vaulted ceilings, and the convenience of washer/dryer hookups.\n\nAt Park at Tuscany, we strive to enrich your lifestyle with a variety of community features. Engage in fitness routines at our on-site fitness center, relax by the sunlit pool, or host gatherings at our stylish clubhouse. Our serene picnic areas are perfect for unwinding after work or enjoying leisure time with neighbors and family. With such proximity to INTEGRIS Health Baptist Medical Center and a host of amenities, Park at Tuscany is where professional demands meet personal satisfaction.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park at Tuscany Near INTEGRIS Baptist Medical",
      "seo_description": "Live at Park at Tuscany near INTEGRIS Health Baptist Medical Center, offering spacious apartments with modern amenities just minutes from work.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-nw-oklahoma-city",
      "search_query": "apartments near Martin Park Nature Center Northwest Oklahoma City",
      "category": "Park",
      "h1_title": "Apts Near Martin Park Nature Center NW OKC",
      "h2_subtitle": "Discover apartments near Martin Park Nature Center in Northwest Oklahoma City. Park at Tuscany offers a tranquil living environment close to nature.",
      "page_copy": "Experience the best of both worlds at Park at Tuscany, located just a short distance from Martin Park Nature Center in Northwest Oklahoma City. For those who cherish having nature at their doorstep, our apartments provide the perfect retreat. Choose from spacious one and two-bedroom floor plans featuring modern amenities like stainless steel appliances, vaulted ceilings, and washer/dryer hookups, all designed to enhance your living experience.\n\nPark at Tuscany is more than just an ideal location; it’s a lifestyle. Enjoy our pool, work out in the fitness center, or host gatherings in our inviting clubhouse. The serene picnic areas around the community are perfect for relaxing weekends or quick breaks. Living near Martin Park Nature Center means easy access to walking trails and outdoor activities. With close proximity to natural beauty and extensive community features, Park at Tuscany is where tranquility meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Martin Park Nature Center NW OKC",
      "seo_description": "Find tranquility at Park at Tuscany, near Martin Park Nature Center NW OKC. Spacious apartments with modern amenities close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-close-to-stars-and-stripes-park-oklahoma-city",
      "search_query": "apartments close to Stars And Stripes Park Oklahoma City",
      "category": "Park",
      "h1_title": "Apts Close to Stars And Stripes Park OKC",
      "h2_subtitle": "Explore Park at Tuscany, offering apartments close to Stars And Stripes Park in Oklahoma City. Enjoy a vibrant lifestyle near recreational spaces.",
      "page_copy": "Park at Tuscany presents the ideal choice for those seeking apartments close to Stars And Stripes Park in Oklahoma City. Located in the vibrant Northwest Oklahoma City neighborhood, our community offers easy access to outdoor activities, perfect for residents with an active lifestyle. Our spacious one and two-bedroom floor plans are equipped with modern amenities including stainless steel appliances, vaulted ceilings, and washer/dryer hookups to provide a comfortable living experience.\n\nIn addition to proximity to Stars And Stripes Park, Park at Tuscany offers a host of on-site amenities to enhance your daily life. Take a refreshing dip in our sunlit pool, work out in the fitness center, or socialize in the well-appointed clubhouse. The community's serene picnic areas are ideal for relaxing afternoons or casual evenings with friends and family. Experience the harmony of urban convenience and suburban tranquility at Park at Tuscany, the gateway to enjoying all that Northwest Oklahoma City has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Stars And Stripes Park OKC",
      "seo_description": "Discover Park at Tuscany's vibrant living, close to Stars And Stripes Park in OKC. Explore spacious apartments with modern amenities and nearby recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-near-bluff-creek-park-ok",
      "search_query": "apartments near Bluff Creek Park OK",
      "category": "Park",
      "h1_title": "Apartments Near Bluff Creek Park OK",
      "h2_subtitle": "Live near Bluff Creek Park at Park at Tuscany. Our apartments provide the perfect blend of nature and modern living in Oklahoma City.",
      "page_copy": "Nestled in a prime location, Park at Tuscany offers convenient apartment living near Bluff Creek Park, Oklahoma. This ideal setting is perfect for those who love outdoor exploration and adventure, with trails and natural beauty just moments away. Our one and two-bedroom apartments feature state-of-the-art amenities including stainless steel appliances and vaulted ceilings, designed for comfort and style.\n\nPark at Tuscany doesn’t just offer a prime location near Bluff Creek Park; it also provides a vibrant community atmosphere. The fitness center is perfect for daily workouts, while the sunlit pool and picnic areas offer relaxation and leisure opportunities. Our clubhouse is great for social events and gatherings. Whether seeking adventure in nearby parks or enjoying the on-site amenities, Park at Tuscany is a haven for those who enjoy active and modern living in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bluff Creek Park OK",
      "seo_description": "Find modern living at Park at Tuscany, offering apartments near Bluff Creek Park OK. Enjoy the outdoors and spacious living in OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165616",
      "source": "generator",
      "page_item_url": "apartments-close-to-mitch-park-73134",
      "search_query": "apartments close to Mitch Park 73134",
      "category": "Park",
      "h1_title": "Apts Close to Mitch Park 73134",
      "h2_subtitle": "Discover Park at Tuscany, offering apartments close to Mitch Park in 73134. Experience comfort and convenience in this prime Oklahoma City location.",
      "page_copy": "Park at Tuscany perfectly captures the essence of comfortable living with its proximity to Mitch Park, located in the 73134 area. Our community offers residents easy access to lush parklands and recreational activities while providing spacious one and two-bedroom apartments with top-tier amenities. Enjoy modern comforts such as stainless steel appliances and vaulted ceilings, perfect for those seeking style and functionality.\n\nEnhance your lifestyle with the range of amenities available at Park at Tuscany. Spend your weekends lounging by the pool, keeping fit in our state-of-the-art fitness center, or enjoying time with friends at the clubhouse. The serene picnic areas provide a haven for relaxation and leisure. Reside at Park at Tuscany and experience the harmony of living close to Mitch Park with all the benefits of a welcoming, well-appointed community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019cfb43-dead-74b6-b4a9-2f61bfe7ed2a",
        "storage_key": "property/6767906449165616/019cfb43-dead-74b6-b4a9-2f61bfe7ed2a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Mitch Park 73134",
      "seo_description": "Enjoy modern living at Park at Tuscany, with apartments close to Mitch Park 73134. Discover comfort and style near Oklahoma City's recreational spots.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5193"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-3Y7GRNPXFT"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151621"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/park-at-tuscany/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P6LSLWXS"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165616/019d1bd9-10da-76ef-aca2-c8768ca0b169.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "9e79e3c1-6c37-458b-8fe5-f3e23296883d"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-431-4061"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64ac4ebab70fcd364fd5dc28"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InNJeVRHemZrMjg2OWl0NE4wRFJJYUE9PSIsInZhbHVlIjoiaEdmKy95OGlwVWdMQUJ0R2h5SEVMZz09IiwibWFjIjoiMDVhOGYwODFlMzg0OTg3M2Q0OTc3ZDQzNDA4MmE2ZmM4MzRiNzdhZDg5MmEwMjlmYjUyODgyOTA1ZDQ4MWZjMCJ9"
    }
  ],
  "custom_qb_id": "5193",
  "custom_ga4_id": "G-3Y7GRNPXFT",
  "custom_repli_id": "10041151621",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/park-at-tuscany/register/",
  "custom_google_gtm_id": "GTM-P6LSLWXS",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165616/019d1bd9-10da-76ef-aca2-c8768ca0b169.pdf",
  "custom_rentgrata_property_id": "9e79e3c1-6c37-458b-8fe5-f3e23296883d",
  "custom_ppc_tracking_phone_number": "844-431-4061",
  "custom_residentboost_apartment_id": "64ac4ebab70fcd364fd5dc28",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InNJeVRHemZrMjg2OWl0NE4wRFJJYUE9PSIsInZhbHVlIjoiaEdmKy95OGlwVWdMQUJ0R2h5SEVMZz09IiwibWFjIjoiMDVhOGYwODFlMzg0OTg3M2Q0OTc3ZDQzNDA4MmE2ZmM4MzRiNzdhZDg5MmEwMjlmYjUyODgyOTA1ZDQ4MWZjMCJ9"
};

export const generatedAt = '2026-08-27T21:37:25.519Z';
